import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { POSITIONS, Tooltip, TYPES } from '@design-system/tooltip';
import { UserTooltipContent } from './UserTooltipContent';
import { UserTooltipContentLoading } from './UserTooltipContentLoading';
const UserTooltipContentWrapper = ({ buttons, content, isLoading, user, }) => {
    if (isLoading) {
        return _jsx(UserTooltipContentLoading, {});
    }
    return _jsx(UserTooltipContent, { buttons: buttons, content: content, user: user });
};
export const UserTooltip = (_a) => {
    var { children, initialPosition = POSITIONS['TOP-RIGHT'], onOpen = () => { } } = _a, props = __rest(_a, ["children", "initialPosition", "onOpen"]);
    return (_jsx(Tooltip, { childrenElement: _jsx(UserTooltipContentWrapper, Object.assign({}, props)), enterDelay: 300, hideOnScreenReader: true, initialPosition: initialPosition, leaveDelay: 300, maxWidth: "330px", onOpen: onOpen, shouldHideArrow: true, textAlign: "left", type: TYPES.CARD, children: children }));
};
export default UserTooltip;
//# sourceMappingURL=UserTooltip.js.map